import * as auth from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs, limit, doc, getDoc } from 'firebase/firestore';
import { User } from 'firebase/auth';
import { AppDispatch, GetState } from "..";
import { signIn as si, signOut as so } from "../slices/authSlice";

export const signIn = (user: User) => async (dispath: AppDispatch, getState: GetState) => {
  const uid = user.uid;
  // Get user info from uid
  const q = query(collection(getFirestore(), 'Employees'), where('uid', '==', uid), limit(1));
  const qSnapshot = await getDocs(q);
  if (qSnapshot.docs.length === 1) {
    const data = qSnapshot.docs[0].data();
    const dataTuple = Object.keys(data).map<[string, any]>((k) => [k, data[k]]);

    // Check if admin or has role
    const adminDoc = await getDoc(doc(getFirestore(), `Admins/${data.idNumber}`));
    if (adminDoc.exists()) {
      dispath(si([...dataTuple, ['URB', adminDoc.data()]]));
    } else {
      dispath(si(dataTuple));
    }
  }
};

export const signOut = () => async (dispath: AppDispatch, getState: GetState) => {
  auth.signOut(auth.getAuth()).then(() => {
    dispath(so());
  });
};